import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

export default {
    components: {
        [CollapseTransition.name]: CollapseTransition
    },
    props: {
        pageClass: {
            type: String,
            default: 'login-page'
        },
        backgroundColor: {
            type: String,
            default: 'white'
        }
    },
    computed: {
        oldAppLogin(){
            return process.env.url.oldAppLogin;
        },
        oldApp(){
            return process.env.url.oldApp;
        }
    },
    data() {
        return {
            showMenu: false,
            backgroundImage: require("../../../../images/register-background.jpg"),
        }
    },
    methods: {
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
    },
    beforeDestroy() {
        this.closeMenu()
    }
}


// WEBPACK FOOTER //
// ./src/components/user/register/auth-layout/auth-layout.js